import { EKeyCode } from '@/enums/e_key_code';
import { service_shortcuts_manager } from '@/services/shortcuts/SERVICE__shortcuts_manager';
import { CALLBACK_keyboard_event } from '@/types/types';
import { use_effect } from '../_base/use_effect';

interface PROPS {
  is_disabled?: boolean;
  prepend_callback?: boolean;
  enable_debugger_breakpoint?: boolean;
}

export function use_shortcut_down(key_codes: EKeyCode[], callback: CALLBACK_keyboard_event, { prepend_callback, enable_debugger_breakpoint }: PROPS = {}) {
  use_effect(() => {
    if (key_codes.is_empty()) return;
    if (enable_debugger_breakpoint) debugger;

    prepend_callback
      ? service_shortcuts_manager.handler_down__prepend(key_codes, callback)
      : service_shortcuts_manager.handler_down__append(key_codes, callback);

    return () => {
      if (!key_codes.is_empty()) service_shortcuts_manager.handler_down__delete(key_codes, callback);
    };
  }, [key_codes, callback]);
}
